import { createSlice } from '@reduxjs/toolkit';
import { PhysicalExamForm } from '../../types/types';

type PhysicalExamKeys = keyof PhysicalExamForm;

interface PhysicalExamAction {
  payload: {
    region: PhysicalExamKeys;
    active: boolean;
    description: string;
  };
  type: string;
}

const initialPhysicalExam: PhysicalExamForm = {
  cabeza: {
    active: false,
    description: ''
  },
  cuello: {
    active: false,
    description: ''
  },
  torax: {
    active: false,
    description: ''
  },
  abdomen: {
    active: false,
    description: ''
  },
  pelvis: {
    active: false,
    description: ''
  },
  extremidades: {
    active: false,
    description: ''
  }
};

const physicalExamSLice = createSlice({
  name: 'physicalExam',
  initialState: initialPhysicalExam,
  reducers: {
    setRegionActive(state, action: PhysicalExamAction) {
      const region = state[action.payload.region];
      if (region == null) return;
      if (!region.active) region.description = '';
      region.active = action.payload.active;
    },
    setRegionDescription(state, action: PhysicalExamAction) {
      const region = state[action.payload.region];
      if (region == null) return;
      region.description = action.payload.description;
    },
    reset() {
      return initialPhysicalExam;
    }
  }
});

export const physicalExamActions = physicalExamSLice.actions;

export default physicalExamSLice.reducer;
